import React, { memo } from 'react';
import SystemComponentCard from './SystemComponentCard';
import SmrUnitCard from './SmrUnitCard';
import ConnectorGroupCard from './ConnectorGroupCard';
import './inventorySection.css';

export type InventorySectionType = 'system' | 'smr' | 'connector';

export type InventoryComponentItem = ISystemComponent | ISmrUnit | IInventoryConnectorGroup;

interface InventorySectionProps {
  icon: string;
  label: string;
  componentCount: number;
  type: InventorySectionType;
  componentList: InventoryComponentItem[];
  className?: string;
}

const InventorySection = memo(function InventorySection({
  icon,
  label,
  componentCount,
  type,
  componentList,
  className,
}: InventorySectionProps) {
  const countNoun = type === 'smr' ? 'units' : 'components';

  const renderBody = (): React.ReactNode => {
    switch (type) {
      case 'system':
        return (
          <div className='inventory__section__grid inventory__section__grid--system'>
            {(componentList as ISystemComponent[]).map((item) => (
              <SystemComponentCard key={item.id} item={item} />
            ))}
          </div>
        );

      case 'smr':
        return (
          componentList?.length > 0 && <div className='inventory__section__smr__container'>
            {(componentList as ISmrUnit[]).map((unit) => (
              <SmrUnitCard key={unit.id} label={unit.label} serial={unit.serial} swVersion={unit.swVersion} hePartNumber={unit.hePartNumber} />
            ))}
          </div>
        );

      case 'connector':
        return (
          <div className='inventory__section__grid inventory__section__grid--connector'>
            {(componentList as IInventoryConnectorGroup[]).map((group) => (
              <ConnectorGroupCard key={group.id} group={group} />
            ))}
          </div>
        );

      default:
        return null;
    }
  };

  return (
    <section className={`inventory__section ${className ?? ''}`}>
      <div className='inventory__section__header'>
        <span className='inventory__section__icon'>
          <span className={`rms__icon inventory__section__icon__glyph ${icon}`} />
        </span>
        <span className='inventory__section__label'>{label}</span>
        <span className='inventory__section__count'>
          {componentCount} {countNoun}
        </span>
      </div>
      {renderBody()}
    </section>
  );
});

export default InventorySection;
